"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReceipt = void 0;
const helpers_1 = require("../../helpers");
const orders_1 = require("../orders");
const roundToTwo_1 = require("../roundToTwo");
const uuid_1 = require("uuid");
const suppliers_1 = require("../suppliers");
const generateReceipt = async (supabase, order_line_ids, order, payment_type, credit_card_fee, // this is the fee GOLFSAVERS charge the client (e.g. 3.5% of the total due)
total_due, // this is how much the client owes WITHOUT the credit card fees applied (e.g. 4700)
merchant_fee, // this is the fee the payment provider charges Golfsavers (e.g. 176.25)
invoice_id) => {
    if (!order.order_lines)
        return;
    try {
        // Setup additional variables
        const total_received = total_due + credit_card_fee;
        const { data: creditCardVatPercentage } = await supabase
            .from("config")
            .select("value")
            .eq("key", "CREDIT_CARD_VAT")
            .single()
            .throwOnError();
        const { data: merchantFeeVatPercentage } = await supabase
            .from("config")
            .select("value")
            .eq("key", "MERCHANT_FEE_VAT")
            .single()
            .throwOnError();
        let credit_card_output_vat = 0;
        let merchant_fee_input_vat = 0;
        if (order.country_id === "187c0a19-e4dc-439b-ab9b-65f363108642") {
            // IF THAILAND
            // If the country is Thailand, we need to apply VAT to the credit card fee
            credit_card_output_vat = (0, roundToTwo_1.roundToTwo)(credit_card_fee -
                credit_card_fee / (1 + creditCardVatPercentage?.value));
            // If the country is Thailand, we need to apply VAT to the merchant fee
            merchant_fee_input_vat = (0, roundToTwo_1.roundToTwo)(merchant_fee -
                merchant_fee / (1 + merchantFeeVatPercentage?.value));
        }
        merchant_fee = (0, roundToTwo_1.roundToTwo)(merchant_fee);
        credit_card_fee = (0, roundToTwo_1.roundToTwo)(credit_card_fee);
        total_due = (0, roundToTwo_1.roundToTwo)(total_due);
        // GENERATE RECEIPT CODE HERE FOR NOW
        const transaction_objs = [];
        const transaction_items = [];
        // Update all order line IDs related to this payment to the percentage set.
        for (let i = 0; i < order_line_ids.length; i++) {
            const order_line_id = order_line_ids[i];
            // get the order line from the order
            const order_line = order.order_lines?.find((ol) => ol.id === order_line_id.id);
            if (!order_line?.versions)
                return;
            // get its latest version
            const latest_version = await (0, orders_1.getLatestOrderLineVersion)(order_line?.versions);
            if (!latest_version)
                return;
            const supplier = await (0, suppliers_1.getSupplierById)(supabase, latest_version.config?.supplier?.id);
            if (!supplier)
                return;
            const line_accountancy = (0, orders_1.getOrderLineAccountancyDetails)(order_line, null, order_line_id.amount_paid, i);
            const total_line_output_vat = line_accountancy.reduce((a, b) => a + b.output_vat, 0);
            const total_line_input_vat = line_accountancy.reduce((a, b) => a + b.input_vat, 0);
            const line_accountancy_obj = {
                output_vat: total_line_output_vat,
                input_vat: total_line_input_vat,
            };
            latest_version.amount_paid =
                order_line_id.amount_paid + latest_version?.amount_paid;
            transaction_objs.push(line_accountancy_obj);
            // // update the version with the payment response
            await (0, orders_1.updateOrderLineVersion)(supabase, latest_version);
        }
        console.log("transaction_objs", transaction_objs);
        const currency = (0, orders_1.getOrderLineCurrency)(order?.order_lines[0]) || "";
        console.log("##############################");
        const transaction_id = (0, uuid_1.v4)();
        // DONE
        console.log("Payment Provider Bank Account (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(total_due + credit_card_fee - merchant_fee));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_due + credit_card_fee - merchant_fee),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getPaymentProviderAccountByCurrencyAndProvider)(currency, payment_type),
            order_line_id: null,
        });
        // DONE
        console.log("Debtors - Clients (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(total_due));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_due),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getClientDebtorsAccountByCurrency)(currency),
            order_line_id: null,
        });
        // DONE
        console.log("Thai VAT (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.output_vat, 0) +
            credit_card_output_vat));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.output_vat, 0) +
                credit_card_output_vat),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getVATAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Thai VAT (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(merchant_fee_input_vat));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(merchant_fee_input_vat),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getVATAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Sales - Golfsavers (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.output_vat, 0) +
            credit_card_output_vat -
            merchant_fee_input_vat));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(transaction_objs.reduce((a, b) => a + b.output_vat, 0) +
                credit_card_output_vat -
                merchant_fee_input_vat),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getRevenueAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Pending Sales - Golfsvers (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(total_due));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_due),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getPendingSalesAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Sales - Golfsvers (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(total_due));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(total_due),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getRevenueAccountByCurrencySource)(currency, order.source),
            order_line_id: null,
        });
        console.log("Sales - Credit Card Fees (THB) | Credit |", (0, roundToTwo_1.roundToTwo)(credit_card_fee));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(credit_card_fee),
            direction: -1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getSalesCreditCardAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Merchant Fees (THB) | Debit |", (0, roundToTwo_1.roundToTwo)(merchant_fee));
        transaction_items.push({
            id: (0, uuid_1.v4)(),
            transaction_id: transaction_id,
            order_id: order.id,
            amount: (0, roundToTwo_1.roundToTwo)(merchant_fee),
            direction: 1,
            currency: currency,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            note: `Receipt for ${order.reference}`,
            account_id: (0, helpers_1.getMerchantFeeAccountByCurrency)(currency),
            order_line_id: null,
        });
        console.log("Transaction (RECEIPT) Value|", (0, roundToTwo_1.roundToTwo)(total_due + credit_card_fee - merchant_fee));
        const transaction = {
            id: transaction_id,
            type: "RECEIPT",
            currency: currency,
            amount: total_due + credit_card_fee - merchant_fee,
            note: `Receipt for ${order.reference}`,
            name_id: order.client_id,
            created_by: helpers_1.ADMIN_USER_ID,
            related_transactions: [invoice_id],
        };
        const transaction_orders = [];
        transaction_orders.push({
            transaction_id: transaction_id,
            order_id: order.id,
        });
        // create the transaction
        await supabase.from("transactions").insert([transaction]);
        await supabase.from("transaction_orders").insert(transaction_orders);
        await supabase.from("transaction_items").insert(transaction_items).select();
        console.log("##############################");
    }
    catch (e) {
        console.log("ERROR", e);
    }
};
exports.generateReceipt = generateReceipt;
